import React from "react";
import i18n from "i18n";
import styles from "./MainApp.organisms.OrdersV3.Item.module.scss";

const Item = ({ title, sku, tagsQuantity, expectedUnits }) => {
  return (
    <div className={styles["item-container"]}>
      <div className={styles["item-title"]}>
        {title}{" "}
        {expectedUnits !== null ? `(${tagsQuantity} / ${expectedUnits})` : ""}
      </div>
      <div className={styles["item-sku"]}>{i18n.t("sku").toUpperCase()} {sku}</div>
      <div className={styles["item-quantity"]}>
        {tagsQuantity} {tagsQuantity > 1 ? i18n.t("Tags") : i18n.t("Tag")}
      </div>
    </div>
  );
};

export default Item;
